<div *ngFor="let file of files; let i = index" class="ce-files-list-item">
  <div class="gse-grid-items">
    <mat-form-field class="gse-grid-item__name" appearance="fill">
      <mat-label>Name</mat-label>
      <input matInput placeholder="" value="{{file.name}}" [(ngModel)]="file.name">
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>URL</mat-label>
      <input matInput placeholder="" [(ngModel)]="file.url" value="{{file.url}}">
    </mat-form-field>
  </div>

  <button mat-icon-button color="primary" aria-label="" (click)="deleteFile(i)">
    <mat-icon>remove</mat-icon>
  </button>
</div>
<button (click)="addFile()" [disabled]="files.length >= 15" mat-stroked-button color="primary">Add File</button>
<!--<button mat-mini-fab color="primary" aria-label="" (click)="addFile()">-->
<!--  <mat-icon>add</mat-icon>-->
<!--</button>-->
<br>
<br>
<div class="btn-bottom-area">
  <button (click)="save()" mat-raised-button color="primary">Save</button>
  <button (click)="cancel()" mat-raised-button color="warn">Cancel</button>
</div>
